export const twemojiSvgBase = "/twemoji";

export function twemojiFilename(grapheme: string): string {
    let codes = Array.from(grapheme).map((x) => x.codePointAt(0)?.toString(16));
    if (!codes.includes("200d")) codes = codes.filter((x) => x !== "fe0f");
    codes = codes.filter((x) => x?.length);
    return codes.join("-");
}

export function twemojiPath(grapheme: string): string {
    return `${twemojiSvgBase}/${twemojiFilename(grapheme)}.svg`;
}
